import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../assets/css/home.css";

/* ── image imports ── */
const banner1  = require("../assets/images/banner-1.jpg");
const banner2  = require("../assets/images/banner-2.jpg");
const banner3  = require("../assets/images/banner-3.jpg");
const prod1    = require("../assets/images/product/product-1.jpeg");
const prod2    = require("../assets/images/product/product-2.jpeg");
const prod3    = require("../assets/images/product/product-3.jpeg");
const prod4    = require("../assets/images/product/product-4.jpeg");
const prod10   = require("../assets/images/product/product-10.png");
const prod12   = require("../assets/images/product/product-12.png");
const prod13   = require("../assets/images/product/product-13.png");
const prod14   = require("../assets/images/product/product-14.png");
const item1    = require("../assets/images/product/item-1.png");
const item2    = require("../assets/images/product/item-2.png");
const herImage1 = require("../assets/images/for-her/image-1.png");
const himImage1 = require("../assets/images/for-him/image-1.png");

/* ── data ── */
const HERO_SLIDES = [
  {
    id: 1,
    img: banner1,
    eyebrow: "Nouvelle Collection",
    title: <>The Art of<br /><em>Fine Fragrance</em></>,
    desc: "Discover our exquisite collection of luxury perfumes, crafted with the world's rarest ingredients to create unforgettable signature scents.",
    cta: "Explore Collection",
    ctaLink: "/collections",
  },
  {
    id: 2,
    img: banner2,
    eyebrow: "Pour Elle",
    title: <>Femininity<br /><em>Redefined</em></>,
    desc: "A universe of floral, oriental and fresh scents curated exclusively for the modern woman. Indulge in pure elegance.",
    cta: "Shop For Her",
    ctaLink: "/for-her",
  },
  {
    id: 3,
    img: banner3,
    eyebrow: "Pour Lui",
    title: <>Bold. Refined.<br /><em>Unforgettable.</em></>,
    desc: "Woody, spicy and aquatic notes blended to perfection. A fragrance as powerful as the man who wears it.",
    cta: "Shop For Him",
    ctaLink: "/for-him",
  },
];

const FEATURES = [
  { icon: "🌿", title: "Natural Ingredients", desc: "Sourced from the world's finest botanical gardens and distilleries." },
  { icon: "🎁", title: "Luxury Packaging", desc: "Every bottle arrives in signature gift-ready packaging." },
  { icon: "✈️", title: "Worldwide Shipping", desc: "Fast, insured delivery to over 120 countries." },
  { icon: "♾️", title: "Lasting Sillage", desc: "Long-lasting formulas that evolve beautifully on your skin." },
];

const BESTSELLERS = [
  { slug: "acqua-di-gio",  img: prod1,  name: "Acqua di Giò",     type: "Eau de Parfum · 100 ml" },
  { slug: "chanel-no5",    img: prod2,  name: "Chanel No. 5",     type: "Eau de Parfum · 50 ml"  },
  { slug: "dior-sauvage",  img: prod3,  name: "Dior Sauvage",     type: "Eau de Toilette · 100 ml"},
  { slug: "ambre-royal",   img: prod4,  name: "Ambre Royal",      type: "Parfum Extrait · 75 ml" },
];

const COLLECTIONS = [
  { id: 1, img: prod10,  tag: "For Her",  link: "/for-her"    },
  { id: 2, img: prod12,  tag: "Unisex",   link: "/collections" },
  { id: 3, img: prod1,   tag: "Oriental", link: "/collections" },
  { id: 4, img: prod14,  tag: "Oud",      link: "/collections" },
  { id: 5, img: prod2,   tag: "Floral",   link: "/collections" },
  { id: 6, img: prod13,  tag: "For Him",  link: "/for-him"    },
];

const SIGNATURE = [
  { img: item1,   name: "Midnight Rose",      detail: "Eau de Parfum · 50 ml",    link: "/product/midnight-rose" },
  { img: item2,   name: "Ocean Breeze",        detail: "Eau de Toilette · 100 ml", link: "/product/ocean-breeze"  },
  { img: prod14,  name: "Oud Wood Absolute",   detail: "Parfum Extrait · 50 ml",   link: "/product/oud-wood"      },
  { img: prod13,  name: "Vanilla Cashmere",    detail: "Eau de Parfum · 75 ml",    link: "/product/vanilla-cashmere" },
];

const TESTIMONIALS = [
  {
    initial: "S",
    name: "Sarah Jenkins",
    role: "Verified Buyer",
    stars: 5,
    text: "The 'For Her' collection is absolutely breathtaking. I receive compliments every single day. Truly a luxurious experience from the exquisite packaging to the incredibly long-lasting fragrance.",
  },
  {
    initial: "M",
    name: "Michael T.",
    role: "Verified Buyer",
    stars: 5,
    text: "I was looking for a fresh, woody scent and the recommendation I received was perfect — sophisticated, not overpowering, and it lasts all day. Perfume Paris is now my only choice.",
  },
  {
    initial: "E",
    name: "Elena R.",
    role: "Verified Buyer",
    stars: 5,
    text: "Bought a gift set for our anniversary. The presentation was gorgeous and the fragrance notes were exactly as described. The customer service team was wonderful in guiding my selection.",
  },
  {
    initial: "D",
    name: "David Chen",
    role: "Fragrance Enthusiast",
    stars: 5,
    text: "As a collector, I am blown away by the complexity and sillage of the artisan range. It rivals niche houses that charge triple the price. A true hidden gem.",
  },
  {
    initial: "L",
    name: "Layla Hassan",
    role: "Verified Buyer",
    stars: 5,
    text: "The Oud Wood Absolute is pure magic — warm, sensual, and incredibly unique. Every compliment I receive leads someone new to this brand. Absolutely worth every penny.",
  },
];

const TICKER_ITEMS = [
  "Free Shipping on Orders Over ₹2000",
  "New Collection Available Now",
  "Authentic Luxury Fragrances",
  "Gift Wrapping Available",
  "Exclusive Members Offers",
  "100% Original Products",
];

/* ── component ── */
const Home = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      {/* ═══════════════════════════════════
          HERO SLIDER
      ═══════════════════════════════════ */}
      <section className="hp-hero">
        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={0}
          loop
          speed={1100}
          autoplay={{ delay: 5500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={{ clickable: true }}
          className="hp-hero"
          style={{ height: "100vh", minHeight: "600px" }}
        >
          {HERO_SLIDES.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="hp-hero-slide">
                <img src={slide.img} alt={slide.eyebrow} className="hp-hero-img" />
                <div className="hp-hero-overlay">
                  <div className="hp-hero-content">
                    <span className="hp-hero-eyebrow">{slide.eyebrow}</span>
                    <h1 className="hp-hero-title">{slide.title}</h1>
                    <p className="hp-hero-desc">{slide.desc}</p>
                    <div className="hp-hero-btns">
                      <Link to={slide.ctaLink} className="btn-gold">{slide.cta}</Link>
                      <Link to="/shop" className="btn-outline-gold">View All</Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* ═══════════════════════════════════
          MARQUEE TICKER
      ═══════════════════════════════════ */}
      <div className="hp-ticker" aria-hidden="true">
        <div className="hp-ticker-track">
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => (
            <span key={i} className="hp-ticker-item">{item}</span>
          ))}
        </div>
      </div>

      {/* ═══════════════════════════════════
          CATEGORY CARDS
      ═══════════════════════════════════ */}
      <section className="hp-categories">
        <div className="container">
          <div className="hp-section-header">
            <span className="hp-section-tag">Explore</span>
            <h2 className="hp-section-title">Shop by <em>Category</em></h2>
            <div className="hp-section-divider"></div>
          </div>
          <div className="row g-4">
            <div className="col-12 col-md-6">
              <Link to="/for-him" className="hp-category-card">
                <img src={himImage1} alt="For Him" />
                <div className="hp-category-overlay">
                  <span className="hp-category-label">Masculine · Bold · Timeless</span>
                  <h3 className="hp-category-name">For Him</h3>
                  <span className="hp-category-btn">Shop Now</span>
                </div>
              </Link>
            </div>
            <div className="col-12 col-md-6">
              <Link to="/for-her" className="hp-category-card">
                <img src={herImage1} alt="For Her" />
                <div className="hp-category-overlay">
                  <span className="hp-category-label">Floral · Sensual · Elegant</span>
                  <h3 className="hp-category-name">For Her</h3>
                  <span className="hp-category-btn">Shop Now</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          BRAND FEATURES STRIP
      ═══════════════════════════════════ */}
      <section className="hp-features">
        <div className="container">
          <div className="row g-3 g-md-0">
            {FEATURES.map((f, i) => (
              <div key={i} className="col-6 col-md-3">
                <div className="hp-feature-item">
                  <span className="hp-feature-icon">{f.icon}</span>
                  <p className="hp-feature-title">{f.title}</p>
                  <p className="hp-feature-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          BEST SELLERS
      ═══════════════════════════════════ */}
      <section className="hp-bestsellers">
        <div className="container">
          <div className="hp-section-header">
            <span className="hp-section-tag">Most Loved</span>
            <h2 className="hp-section-title">Best <em>Sellers</em></h2>
            <div className="hp-section-divider"></div>
          </div>

          <div style={{ position: "relative", padding: "0 28px" }}>
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={24}
              slidesPerView={1}
              loop
              speed={800}
              autoplay={{ delay: 4200, disableOnInteraction: false, pauseOnMouseEnter: true }}
              navigation={{ nextEl: ".hp-bs-next", prevEl: ".hp-bs-prev" }}
              breakpoints={{
                576:  { slidesPerView: 2, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 24 },
              }}
            >
              {BESTSELLERS.map((p) => (
                <SwiperSlide key={p.slug}>
                  <Link to={`/product/${p.slug}`} className="hp-product-card">
                    <div className="hp-product-img-wrap">
                      <img src={p.img} alt={p.name} />
                    </div>
                    <div className="hp-product-info">
                      <p className="hp-product-name">{p.name}</p>
                      <p className="hp-product-type">{p.type}</p>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>

            <button className="hp-nav-btn prev hp-bs-prev" aria-label="Previous">&#8592;</button>
            <button className="hp-nav-btn next hp-bs-next" aria-label="Next">&#8594;</button>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          NEW COLLECTIONS GRID
      ═══════════════════════════════════ */}
      <section className="hp-collections">
        <div className="container">
          <div className="hp-section-header">
            <span className="hp-section-tag">Just Arrived</span>
            <h2 className="hp-section-title">New <em>Collections</em></h2>
            <div className="hp-section-divider"></div>
          </div>

          <div className="row g-3">
            {COLLECTIONS.map((c) => (
              <div key={c.id} className="col-6 col-md-4">
                <Link to={c.link} className="hp-collection-card">
                  <img src={c.img} alt={c.tag} />
                  <div className="hp-collection-overlay">
                    <span className="hp-collection-tag">{c.tag}</span>
                  </div>
                  <div className="hp-collection-cta">
                    <span>Discover</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <Link to="/shop" className="btn-gold">Browse All Fragrances</Link>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          EDITORIAL / BRAND PROMISE BANNER
      ═══════════════════════════════════ */}
      <section className="hp-editorial">
        <div className="container">
          <h2 className="hp-editorial-title">
            A Fragrance Is Not Just a Scent —<br />It Is a <em style={{ fontStyle: "italic" }}>Memory</em>
          </h2>
          <p className="hp-editorial-sub">
            At Perfume Paris, every bottle tells a story. We believe true luxury lies
            in the details — the rare ingredients, the expert blending, and the moment
            the first spray takes you somewhere extraordinary.
          </p>
          <Link to="/about" className="btn-white">Our Story</Link>
        </div>
      </section>

      {/* ═══════════════════════════════════
          SIGNATURE COLLECTIONS (Featured 4)
      ═══════════════════════════════════ */}
      <section className="hp-signature">
        <div className="container">
          <div className="hp-section-header">
            <span className="hp-section-tag">Discover</span>
            <h2 className="hp-section-title">Signature <em>Collections</em></h2>
            <div className="hp-section-divider"></div>
          </div>

          <div className="row g-4 justify-content-center">
            {SIGNATURE.map((s, i) => (
              <div key={i} className="col-6 col-md-3">
                <Link to={s.link} className="hp-sig-card">
                  <div className="hp-sig-img-wrap">
                    <img src={s.img} alt={s.name} />
                    <div className="hp-sig-hover-bar"></div>
                  </div>
                  <div className="hp-sig-info">
                    <p className="hp-sig-name">{s.name}</p>
                    <p className="hp-sig-detail">{s.detail}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <Link to="/shop" className="btn-gold">View All Collections</Link>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════
          TESTIMONIALS
      ═══════════════════════════════════ */}
      <section className="hp-testimonials">
        <div className="container">
          <div className="hp-section-header light">
            <span className="hp-section-tag">Testimonials</span>
            <h2 className="hp-section-title" style={{ color: "#fff" }}>
              What Our <em>Customers</em> Say
            </h2>
            <div className="hp-section-divider"></div>
            <p className="mt-3" style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.9rem", fontFamily: "var(--sans)", maxWidth: 520, margin: "16px auto 0" }}>
              Thousands of fragrance lovers trust Perfume Paris for their most cherished moments.
            </p>
          </div>

          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            loop
            speed={900}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            pagination={{ clickable: true, el: ".hp-testi-pagination" }}
            breakpoints={{
              640:  { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            style={{ paddingBottom: "50px" }}
          >
            {TESTIMONIALS.map((t, i) => (
              <SwiperSlide key={i}>
                <div className="hp-testi-card">
                  <span className="hp-testi-quote">"</span>
                  <span className="hp-testi-stars">{"★".repeat(t.stars)}</span>
                  <p className="hp-testi-text">"{t.text}"</p>
                  <div className="hp-testi-author">
                    <div className="hp-testi-avatar">{t.initial}</div>
                    <div>
                      <p className="hp-testi-name">{t.name}</p>
                      <p className="hp-testi-role">{t.role}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="hp-testi-pagination swiper-pagination" style={{ textAlign: "center" }}></div>
        </div>
      </section>
    </>
  );
};

export default Home;
